import { Component } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { HelpersService } from "src/app/core/services/helpers.service";
import { OperationsService } from "src/app/core/services/operations.service";
import { PropertiesSettings as ps } from '../../../core/configuration/properties-settings';
import {
  PetitumRevisioneAdapter
} from "../../components/fascicolo/sezione-economica-valore-add-revisione/petitum-revisione-adapter";
import { Controparte } from "../../models/controparte";
import { SezioneContropartiResponse } from "../../models/dto/sezione-controparti-response";
import { FondoRischioControparte } from "../../models/fondo-rischio-controparte";
import { PetitumRevisione } from "../../models/petitum-revisione";
import { SezioneEconomica } from "../../models/sezioni/sezione-economica";
import { GradoRischio } from "../../models/tipologiche/grado-rischio";
import { SoggettoPratica } from "../../models/tipologiche/soggetto-pratica";
import { NumericOperationManager } from "../../utils/numeric-operation-manager";
import { UtilityCommon } from "../../utils/utility-common";
import { BaseForm } from "../base-Form";


@Component({
  selector: 'div [fondo-rischi-revisione-form-add]',
  templateUrl: 'fondo-rischi-revisione-form.component.html'
})

export abstract class FondoRischiRevisioneFormComponent extends BaseForm {

  request: PetitumRevisione;
  fondoRischioControparte: FondoRischioControparte = new FondoRischioControparte();
  gradiRischioOptions: GradoRischio[] = [];
  societaOptions: SoggettoPratica[] = [];
  petitumRevisioneForm: FormGroup;
  idTipoRevisioneWizard = ps.ID_TIPO_REVISIONE_WIZARD;
  controparti: Controparte[] = [];
  isPercentualeSoccombenza: boolean;
  requestReset: PetitumRevisione;
  idSezioneControparti: string;
  urlSezioneControparti: string;
  isModifica: boolean = false;
  addedRipartizioneEqua: boolean = false;
  canModifyRipartizioneEqua: boolean = true;
  index: number;
  calcolaSomma = UtilityCommon.calcolaSomma;
  originalSorteTotale: number;
  originalSpeseGiudizioTotale: number;
  originalInteressiTotale: number;

  tipoInserimento = [{
    label: 'Automatico',
    descrizione: 'Automatico',
    rimosso: false,
    id: 1
  },
  {
    label: 'Manuale',
    descrizione: 'Manuale',
    rimosso: false,
    id: 2
  }
  ]
  tipoInserimentoSel: any;
  tipoInserimentoReset: any;
  abstract getPetitumRevisione(): PetitumRevisione;
  abstract getRequest(request: PetitumRevisione);
  abstract getSezione(): SezioneEconomica;
  abstract closeModal();

  constructor(protected operationService: OperationsService,
              protected campiForm: FormBuilder,
              protected helpers: HelpersService) {
    super();
  }

  initRequest() {
    this.request = new PetitumRevisioneAdapter(this.getPetitumRevisione()).petitumRevisione;
    this.request.tipoPetitum = this.getSezione().petitum.tipoPetitum;
    this.requestReset = { ...this.request };
  }

  setDefaultRipartizioneEqua() {
    if (this.request.fondorischiControparti.length > 0) {
      this.addedRipartizioneEqua = this.request.ripartizioneEqua ? true : false;
      this.canModifyRipartizioneEqua = false;
    }
  }

  createForm(isPercentualeSoccombenza: boolean = false) {
    this.isModifica = false;
    this.addedRipartizioneEqua = false;
    this.isPercentualeSoccombenza = isPercentualeSoccombenza;
    this.tipoInserimentoSel = null;
    this.initRequest();
    if (!isPercentualeSoccombenza) {
      this.petitumRevisioneForm = this.campiForm.group({
        societa: [this.fondoRischioControparte.societa],
        controparte: [this.fondoRischioControparte.controparte],
        dataRevisioneDa: [this.request.dataRevisioneDa],
        gradoRischio: [this.request.gradoRischio],
        motivoRevisione: [this.request.motivoRevisione],
        ripartizioneEqua: [this.request.ripartizioneEqua],
        sorte: [this.fondoRischioControparte.sorte],
        speseGiudizio: [this.fondoRischioControparte.speseGiudizio],
        interessi: [this.fondoRischioControparte.interessi],
        rivalutazione: [this.fondoRischioControparte.rivalutazione],
        // assistenziali:  [this.fondoRischioControparte.assistenziali],
        // previdenziali:  [this.fondoRischioControparte.previdenziali],
        // tfr:  [this.fondoRischioControparte.tfr]
        importiTotali: [this.request.importiTotali],
        interessiSpeseLegali: [this.request.interessiSpeseLegali],
        interesseFR: [this.request.interesseFR],
        speseFR: [this.request.speseFR],
        importoFR: [this.request.importoFR],
      });
    } else {
      if (this.getSezione() && this.getSezione().petitum && this.getSezione().petitum.percentualeSoccombenza) {
        this.request.percentualeSoccombenza = this.getSezione().petitum.percentualeSoccombenza;
      }
    }
    if (!this.request.id && this.request.id === undefined) {
      this.tipoInserimentoSel = this.tipoInserimento[0]; //AUTOMATICO
    } else {
      if (this.request.fondorischiControparti.length > 0 || this.request.importiTotali) {
        this.tipoInserimentoSel = this.tipoInserimento[1]
      }else{
        this.tipoInserimentoSel = this.tipoInserimento[0]; //AUTOMATICO
      }
      
    }

    this.tipoInserimentoReset = {...this.tipoInserimentoSel};
    this.fondoRischioControparte = new FondoRischioControparte();
    if (this.inserimento) {
      this.request.fondorischiControparti = [];
    }
    //if(!this.inserimento) this.setDefaultRipartizioneEqua();
  }

  resetForm() {
    this.fondoRischioControparte = new FondoRischioControparte();
    this.request.ripartizioneEqua = false;
    this.request = {...this.requestReset};
    this.tipoInserimentoSel = {...this.tipoInserimentoReset};
    this.isModifica = false;
    this.originalSorteTotale = null;
    this.originalSpeseGiudizioTotale = null;
    this.originalInteressiTotale = null;
    /*this.request.fondorischiControparti.forEach(el => this.eliminaFondoRischio(el));
    this.resetToggles();*/
    this.populateSelect(this.urlSezioneControparti, this.idSezioneControparti);
  }

  approssimaImporto(importo): number {
    let num = Number(importo);
    return Math.trunc(100 * num) / 100;
  }

  approssimaTotale(importo): number {
    let num = Number(importo);
    return (Math.abs(num - Math.round(num)) < 0.1) ? Math.round(num) : num;
  }

  populateSelect(urlSezioneControparti: string, idSezioneControparti: string) {
    this.idSezioneControparti = idSezioneControparti;
    this.urlSezioneControparti = urlSezioneControparti;
    if (idSezioneControparti) {
      this.operationService.readSezione(urlSezioneControparti, idSezioneControparti)
        .subscribe(response => {
          this.controparti = (<SezioneContropartiResponse>response).sezione.controparti;
          this.filtraControparti();
        });
    }
    if (this.gradiRischioOptions.length === 0) {
      this.helpers.getGradiRischio().subscribe(response => this.gradiRischioOptions = response);
    }
    if (this.societaOptions.length === 0) {
      this.helpers.getSoggetti().subscribe(response => this.societaOptions = response);
    }
  }

  filtraControparti() {
    if (!this.inserimento && !this.request.ripartizioneEqua && this.request.fondorischiControparti.length > 0) {
      this.controparti = this.controparti.filter(element => !this.request.fondorischiControparti.find(el => el.controparte.id === element.id));
    }
  }

  settaPercentualeSoccombenza(idGrado: any) {
    let percentuale = undefined;
    if (this.tipoInserimentoSel.id === 1) {
      if (idGrado) {
        let grado = this.gradiRischioOptions.filter(g => g.id === idGrado)[0];
        if (grado) {
          percentuale = grado.percentualeSoccombenza;
        }
      }
      if (percentuale != undefined)
        this.request.percentualeSoccombenza = String(percentuale);
      else
        this.request.percentualeSoccombenza = undefined;
    }
  }

  aggiungi() {
    if (!this.request.ripartizioneEqua) {
      /*if(!this.inserimento && this.isModifica){
        let newListFondoRischi: FondoRischioControparte[] = this.request.fondorischiControparti.filter(el=>
        {return (el.controparte.id!=this.fondoRischioControparte.controparte.id);});
        this.request.fondorischiControparti=newListFondoRischi;
      }*/
      if (this.isModifica && !this.request.ripartizioneEqua) {
        this.request.fondorischiControparti[this.request.fondorischiControparti.findIndex(fr => fr.controparte.id === this.fondoRischioControparte.controparte.id)] = { ...this.fondoRischioControparte };
        this.isModifica = false;
        this.controparti = this.controparti.filter(el => el.id != this.fondoRischioControparte.controparte.id);
      } else {
        this.request.ripartizioneEqua = false;
        this.request.fondorischiControparti.push(this.fondoRischioControparte);
        this.controparti = this.controparti.filter(el => el.id != this.fondoRischioControparte.controparte.id);
        this.canModifyRipartizioneEqua = false;
        this.addedRipartizioneEqua = false;
        this.isModifica = false;
      }
    }
    else {
      this.ripartizioneEquaFondoRischi();
      this.addedRipartizioneEqua = true;
      this.canModifyRipartizioneEqua = false;
    }
    this.fondoRischioControparte = new FondoRischioControparte();
  }

  ripartizioneEquaFondoRischi() {
    if (this.isModifica) {
      this.request.fondorischiControparti = [];
      this.isModifica = false;
    }
    if (this.controparti.length > 0) {
      this.controparti.forEach(el => {
        let fondoRischio = new FondoRischioControparte();
        //fondoRischio.ripartizioneEqua = this.request.ripartizioneEqua;
        fondoRischio.societa = this.fondoRischioControparte.societa;
        fondoRischio.controparte = el;
        fondoRischio.sorte = this.fondoRischioControparte.sorte;
        fondoRischio.interessi = this.fondoRischioControparte.interessi;
        fondoRischio.rivalutazione = this.fondoRischioControparte.rivalutazione;
        fondoRischio.assistenziali = this.fondoRischioControparte.assistenziali;
        fondoRischio.previdenziali = this.fondoRischioControparte.previdenziali;
        fondoRischio.tfr = this.fondoRischioControparte.tfr;
        fondoRischio.speseGiudizio = this.fondoRischioControparte.speseGiudizio;
        this.originalSorteTotale = this.fondoRischioControparte.sorte;
        this.originalSpeseGiudizioTotale = this.fondoRischioControparte.speseGiudizio;
        this.originalInteressiTotale = this.fondoRischioControparte.interessi;
        this.request.fondorischiControparti.push(fondoRischio);
      });
    }
  }

  formatta(...args: string[]) {
    return NumericOperationManager.getSum(args)
  }

  cacolaRipartizione(attr, fondorischioControparte: FondoRischioControparte) {
    let ripartizione = 0;
    ripartizione = fondorischioControparte[attr] ? fondorischioControparte[attr] / this.request.fondorischiControparti.length : 0;
    return this.formatta(this.approssimaImporto(ripartizione).toString());
    //ripartizione = fondorischioControparte[attr] ? fondorischioControparte[attr] / this.request.fondorischiControparti.length : 0;
    //return parseFloat(this.approssimaImporto(ripartizione).toString().replace(',', '.'));
      /*fondoRischio.sorte = (this.fondoRischioControparte.sorte) ? Number(this.fondoRischioControparte.sorte) / this.controparti.length : 0;
      fondoRischio.interessi = (this.fondoRischioControparte.interessi) ? Number(this.fondoRischioControparte.interessi) / this.controparti.length : 0;
      fondoRischio.rivalutazione = (this.fondoRischioControparte.rivalutazione) ? Number(this.fondoRischioControparte.rivalutazione) / this.controparti.length : 0;
      fondoRischio.assistenziali = (this.fondoRischioControparte.assistenziali) ? Number(this.fondoRischioControparte.assistenziali) / this.controparti.length : 0;
      fondoRischio.previdenziali = (this.fondoRischioControparte.previdenziali) ? Number.parseFloat(this.fondoRischioControparte.previdenziali.toString()) / this.controparti.length : 0;
      fondoRischio.tfr = (this.fondoRischioControparte.tfr) ? Number.parseFloat(this.fondoRischioControparte.tfr.toString()) / this.controparti.length : 0;
      fondoRischio.speseGiudizio = (this.fondoRischioControparte.speseGiudizio) ? Number.parseFloat(this.fondoRischioControparte.speseGiudizio.toString()) / this.controparti.length : 0;*/
  }

  changeInserimento(event) {
    this.request.percentualeSoccombenza = null;
    this.request.gradoRischio = null;
    this.tipoInserimentoSel = event; 
    this.resetParametri();
  }

  changeControparte() {
    this.request.importiTotali = false;
    this.request.ripartizioneEqua = false;
    //azzerare gli importi totali
  }

  resetParametri() {
    this.request.fondorischiControparti = [];
    this.request.importiTotali = false;
    this.request.ripartizioneEqua = false;
    this.addedRipartizioneEqua = false;
    this.request.speseFR = null;
    this.request.interesseFR = null;
    this.request.importoFR = null;
    this.fondoRischioControparte = new FondoRischioControparte();
    this.isModifica = false;
    this.originalSorteTotale = null;
    this.originalSpeseGiudizioTotale = null;
    this.originalInteressiTotale = null;
    //azzerare gli importi totali
  }

  eliminaRipartizione() {
    this.isModifica = false;
    this.resetParametri();
  }

  save() {
    const req = JSON.parse(JSON.stringify(this.request));
    if(this.request.ripartizioneEqua && this.request.fondorischiControparti && this.request.fondorischiControparti.length > 0){
      // Uso i valori originali, se presenti; altrimenti Uso i valori correnti della request
      const sorteTotale = this.originalSorteTotale != null ? this.originalSorteTotale : this.calcolaTotale('sorte',req);
      const speseGiudizioTotale = this.originalSpeseGiudizioTotale != null ? this.originalSpeseGiudizioTotale : this.calcolaTotale('speseGiudizio',req);
      const interessiTotale = this.originalInteressiTotale != null ? this.originalInteressiTotale : this.calcolaTotale('interessi',req);

      // Aggiorno i valori per ciascuna controparte, solo se i totali non sono null
      if (sorteTotale !== null) {
        req.fondorischiControparti.forEach(el => {
              el.sorte = sorteTotale;
        });
      }
      if (speseGiudizioTotale !== null) {
        req.fondorischiControparti.forEach(el => {
            el.speseGiudizio = speseGiudizioTotale;
        });
      }
      if (interessiTotale !== null) {
        req.fondorischiControparti.forEach(el => {
            el.interessi = interessiTotale;
        });
      }
    }
    let requestCopy: PetitumRevisione = (new PetitumRevisioneAdapter(req)).petitumRevisione;
    this.getRequest(requestCopy);
  }

  calcolaTotale(attr: string, req:any): number {
    if (!req.fondorischiControparti || req.fondorischiControparti.length === 0) {
        return 0; // Se non ci sono controparti, restituisci 0
    }
    // Somma i valori per ogni controparte
    return req.fondorischiControparti.reduce((acc, el) => acc + (el[attr] || 0), 0);
  }

  // openModFondorischioControparte(fondoRischioControparte: FondoRischioControparte) {
  //   if (this.request.ripartizioneEqua) {
  //     this.fondoRischioControparte = this.request.fondorischiControparti[0];
  //   } else {
  //     this.fondoRischioControparte = this.request.fondorischiControparti.find(el => el.controparte.id === fondoRischioControparte.controparte.id);
  //   }
  //   // this.createForm();
  // }

  modificaRipartizioneEqua() {
    //this.request.fondorischiControparti.forEach(el => this.controparti.push(el.controparte));
    if (this.request.fondorischiControparti[0].id) {
      let newRequest = new FondoRischioControparte();
      newRequest.societa = this.request.fondorischiControparti[0].societa;
      newRequest.controparte = null;
      newRequest.sorte = this.approssimaTotale(this.approssimaImporto(Number(this.request.fondorischiControparti[0].sorte) * this.request.fondorischiControparti.length));
      newRequest.interessi = this.approssimaTotale(this.approssimaImporto(Number(this.request.fondorischiControparti[0].interessi) * this.request.fondorischiControparti.length));
      newRequest.rivalutazione = this.approssimaTotale(this.approssimaImporto(Number(this.request.fondorischiControparti[0].rivalutazione) * this.request.fondorischiControparti.length));
      newRequest.speseGiudizio = this.approssimaTotale(this.approssimaImporto(Number(this.request.fondorischiControparti[0].speseGiudizio) * this.request.fondorischiControparti.length));
      newRequest.assistenziali = this.approssimaTotale(this.approssimaImporto(Number(this.request.fondorischiControparti[0].assistenziali) * this.request.fondorischiControparti.length));
      newRequest.previdenziali = this.approssimaTotale(this.approssimaImporto(Number(this.request.fondorischiControparti[0].previdenziali) * this.request.fondorischiControparti.length));
      newRequest.tfr = this.approssimaTotale(this.approssimaImporto(Number(this.request.fondorischiControparti[0].tfr) * this.request.fondorischiControparti.length));
      this.fondoRischioControparte = newRequest;
    }else{
      let newRequest = new FondoRischioControparte();
      newRequest.societa = this.request.fondorischiControparti[0].societa;
      newRequest.controparte = null;
      newRequest.sorte = this.request.fondorischiControparti[0].sorte;
      newRequest.interessi = this.request.fondorischiControparti[0].interessi;
      newRequest.rivalutazione = this.request.fondorischiControparti[0].rivalutazione;
      newRequest.speseGiudizio = this.request.fondorischiControparti[0].speseGiudizio;
      newRequest.assistenziali = this.request.fondorischiControparti[0].assistenziali;
      newRequest.previdenziali = this.request.fondorischiControparti[0].previdenziali;
      newRequest.tfr = this.request.fondorischiControparti[0].tfr;
      this.fondoRischioControparte = newRequest;
    }
    this.canModifyRipartizioneEqua = false;
    this.isModifica = true;
  }

  modificaSingoloFondoRischio(fondoRischioControparte: FondoRischioControparte) {
    if(this.controparti.findIndex(el => el.id === fondoRischioControparte.controparte.id) === -1){
      this.controparti.push(fondoRischioControparte.controparte);
    }
    this.controparti = this.controparti.sort((leftSide, rigthSide): number => {
      if (leftSide.parte.nominativo < rigthSide.parte.nominativo) return -1;
      if (leftSide.parte.nominativo > rigthSide.parte.nominativo) return 1;
      return 0;
    });
    let newRequest = new FondoRischioControparte();
    newRequest.id = fondoRischioControparte.id;
    newRequest.societa = fondoRischioControparte.societa;
    newRequest.controparte = fondoRischioControparte.controparte;
    this.request.ripartizioneEqua = false;
    newRequest.sorte = fondoRischioControparte.sorte;
    newRequest.interessi = fondoRischioControparte.interessi;
    newRequest.rivalutazione = fondoRischioControparte.rivalutazione;
    newRequest.speseGiudizio = fondoRischioControparte.speseGiudizio;
    newRequest.assistenziali = fondoRischioControparte.assistenziali;
    newRequest.previdenziali = fondoRischioControparte.previdenziali;
    newRequest.tfr = fondoRischioControparte.tfr;
    this.fondoRischioControparte = newRequest;
    this.isModifica = true;
  }

  eliminaFondoRischio(fondoRischioControparte: FondoRischioControparte) {
    this.request.fondorischiControparti = this.request.fondorischiControparti.filter(el => el != fondoRischioControparte);
    if (!this.controparti.find(el => el.id === fondoRischioControparte.controparte.id)) {
      this.controparti.push(fondoRischioControparte.controparte);
    }
    this.controparti = this.controparti.sort((leftSide, rigthSide): number => {
      if (leftSide.parte.nominativo < rigthSide.parte.nominativo) return -1;
      if (leftSide.parte.nominativo > rigthSide.parte.nominativo) return 1;
      return 0;
    });
    if (this.request.fondorischiControparti.length === 0) {
      this.canModifyRipartizioneEqua = true;
      this.isModifica = false;
    }
  }

  onChangeRipartizioneEqua(event) {
    this.request.ripartizioneEqua = event;
    this.request.importiTotali = false;
    this.fondoRischioControparte = new FondoRischioControparte();
    this.request.fondorischiControparti = [];
    if (event) {
      this.fondoRischioControparte.controparte = null;
    }
  }

  onChangeImportiTotali(event) {
    this.request.importiTotali = event;
    this.request.ripartizioneEqua = false;
    this.fondoRischioControparte = new FondoRischioControparte();
    this.request.fondorischiControparti = [];
    this.originalSorteTotale = null;
    this.originalSpeseGiudizioTotale = null;
    this.originalInteressiTotale = null;
  }

  resetToggles() {
    this.addedRipartizioneEqua = false;
    this.isModifica = false;
    this.canModifyRipartizioneEqua = true;
  }

  annulla() {
    this.closeModal();
    this.resetToggles();
    this.createForm();
  }
}
